import { UsersPage } from '@/components/pages'

const UsersRoute = () => {
  return <UsersPage />
}

UsersRoute.layouts = 'content'
UsersRoute.displayName = 'UsersRoute'
export default UsersRoute
